/**
 * FeedTags Service
 *
 * Domain layer service for feed tags operations.
 * Singleton pattern matching other service singletons.
 *
 * Architecture:
 * UseCase → FeedTagsService → CloudFunctionsService
 *
 * Flutter source of truth:
 *   - lib/data/repository/feed_tags_repository.dart
 *   - lib/services/cloud_functions_service.dart:971-981
 */

import { cloudFunctionsService } from '@/data/services/cloudFunctionsService';

export class FeedTagsService {
  private static instance: FeedTagsService;

  private constructor() { }

  public static getInstance(): FeedTagsService {
    if (!FeedTagsService.instance) {
      FeedTagsService.instance = new FeedTagsService();
    }
    return FeedTagsService.instance;
  }

  /**
   * Trigger the `processFeedTags` cloud function for the given content id.
   * Fire-and-forget — errors are already swallowed at the data layer.
   */
  async processFeedTagsWatch(contentId: string): Promise<void> {
    await cloudFunctionsService.processFeedTags(contentId);
  }
}

export const feedTagsService = FeedTagsService.getInstance();
